import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Button } from 'antd';

class NewFilterText extends PureComponent {
  _onValidate = (err, formValues) => {
    const { onSubmitForm } = this.props;
    if (!err) {
      onSubmitForm(formValues.input);
    }
  };

  handleSubmit = e => {
    e.preventDefault();
    const {
      form: { validateFields },
    } = this.props;

    validateFields(this._onValidate);
  };

  render = () => {
    const { onCancelForm, validations, label } = this.props;
    const { getFieldDecorator } = this.props.form;

    const rules = [
      {
        required: true,
        message: 'input required',
      },
    ];

    if (validations) {
      validations.forEach(x => rules.push(x));
    }

    return (
      <Form onSubmit={this.handleSubmit}>
        <Form.Item required={false} colon={false}>
          {getFieldDecorator('input', {
            rules,
          })(
            <Input
              placeholder={label}
              size="large"
              ref={refs => {
                refs.focus();
              }}
            />,
          )}
        </Form.Item>
        <Button className="btn cancel-btn" onClick={onCancelForm}>
          Cancel
        </Button>
        <Button type="primary" htmlType="submit" className="btn">
          Submit
        </Button>
      </Form>
    );
  };
}

NewFilterText.propTypes = {
  form: PropTypes.object,
  onCancelForm: PropTypes.func,
  onSubmitForm: PropTypes.func,
  label: PropTypes.string,
  validations: PropTypes.array,
};

export default NewFilterText;
